'use strict';

var core = require('core/components/clientSideValidation');

core.submit = function() {
    $('form:not(.formstack-form form)').on('submit', function (e) {
        return core.functions.validateForm.call(this, e);
    });
}

module.exports = core;
